// primary states
const SOLD = 'Sold';
const CANCELLED = 'Cancelled';

// seatwave states
const LISTED_ON_SECONDARY_MARKET = 'listed_on_secondary_market';
const SOLD_ON_SECONDARY_MARKET = 'sold_on_secondary_market';

// layout types
const TYPE_LEVEL_SECTION_ROW_SEAT_TICKET = 'TYPE_LEVEL_SECTION_ROW_SEAT_TICKET';
const TYPE_SECTION_ROW_SEAT_TICKET = 'TYPE_SECTION_ROW_SEAT_TICKET';
const TYPE_LEVEL_SECTION_ROW_TICKET = 'TYPE_LEVEL_SECTION_ROW_TICKET';
const TYPE_LEVEL_ROW_SEAT_TICKET = 'TYPE_LEVEL_ROW_SEAT_TICKET';
const TYPE_SECTION_ROW_TICKET = 'TYPE_SECTION_ROW_TICKET';
const TYPE_LEVEL_SECTION_TICKET = 'TYPE_LEVEL_SECTION_TICKET';
const TYPE_LEVEL_TICKET = 'TYPE_LEVEL_TICKET';
const TYPE_SECTION_TICKET = 'TYPE_SECTION_TICKET';
const LEVEL_SECTION_ROW_SEAT_TICKET = 'LEVEL_SECTION_ROW_SEAT_TICKET';
const LEVEL_ROW_SEAT_TICKET = 'LEVEL_ROW_SEAT_TICKET';
const SECTION_ROW_SEAT_TICKET = 'SECTION_ROW_SEAT_TICKET';
const LEVEL_SECTION_TICKET = 'LEVEL_SECTION_TICKET';
const LEVEL_TICKET = 'LEVEL_TICKET';
const SECTION_TICKET = 'SECTION_TICKET';
const UPSELL = 'UPSELL';

export default  {
  SOLD: SOLD,
  CANCELLED: CANCELLED,
  SOLD_ON_SECONDARY_MARKET: SOLD_ON_SECONDARY_MARKET,
  UPSELL: UPSELL,
  LEVEL_TICKET: LEVEL_TICKET,
  SECTION_TICKET: SECTION_TICKET,
  TYPE_LEVEL_TICKET: TYPE_LEVEL_TICKET,
  TYPE_SECTION_TICKET: TYPE_SECTION_TICKET,
  TYPE_LEVEL_ROW_SEAT_TICKET: TYPE_LEVEL_ROW_SEAT_TICKET,
  TYPE_LEVEL_SECTION_ROW_SEAT_TICKET: TYPE_LEVEL_SECTION_ROW_SEAT_TICKET,
  TYPE_SECTION_ROW_SEAT_TICKET: TYPE_SECTION_ROW_SEAT_TICKET,
  TYPE_LEVEL_SECTION_ROW_TICKET: TYPE_LEVEL_SECTION_ROW_TICKET,
  TYPE_SECTION_ROW_TICKET: TYPE_SECTION_ROW_TICKET,
  TYPE_LEVEL_SECTION_TICKET: TYPE_LEVEL_SECTION_TICKET,
  LEVEL_SECTION_ROW_SEAT_TICKET: LEVEL_SECTION_ROW_SEAT_TICKET,
  SECTION_ROW_SEAT_TICKET: SECTION_ROW_SEAT_TICKET,
  LEVEL_ROW_SEAT_TICKET: LEVEL_ROW_SEAT_TICKET,
  LEVEL_SECTION_TICKET: LEVEL_SECTION_TICKET,
  LISTED_ON_SECONDARY_MARKET: LISTED_ON_SECONDARY_MARKET
};



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/ticket_states.js